/* unplugin-vue-components disabled */import { render } from "./LogicalReasoningRender.vue?vue&type=template&id=e0e7bb68&scoped=true"
import script from "./LogicalReasoningRender.vue?vue&type=script&lang=js"
export * from "./LogicalReasoningRender.vue?vue&type=script&lang=js"

import "./LogicalReasoningRender.vue?vue&type=style&index=0&id=e0e7bb68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0e7bb68"]])

export default __exports__